import React, { useEffect, useState } from "react";
import ReactEcharts from "echarts-for-react";
import appconstant from "../../../themes/appconstant";
import { Tabs, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { postActivityLoad } from "../../../redux/slices/dash.slice";

const { Option } = Select;

const VisitorChart = ({ orgId, department }) => {
  const dispatch = useDispatch();
  const [active, setActive] = useState("community");
  const [selectedMonth, setSelectedMonth] = useState(
    moment().month().toString()
  ); // Set default value to current month index
  const graphData = useSelector(
    (state) => state.dashboardReducer.postActivityData
  );
  const post = graphData ? graphData[0]?.post : {};
  const comment = graphData ? graphData[0]?.comment : {};

  const data = {
    activityType: active,
    month: selectedMonth,
    organisation: orgId,
  };

  useEffect(() => {
    dispatch(postActivityLoad({ ...data, department }));
  }, [active, selectedMonth, department]);

  const items = [
    {
      key: "community",
      label: "Community",
    },
    {
      key: "innerCircle",
      label: "Inner Circle",
    },
  ];

  const handleMonthChange = (value) => {
    setSelectedMonth(value);
  };

  const onChange = (key) => {
    setActive(key);
  };

  var noOfPostData = Object.values(post);
  var noOfCommentsData = Object.values(comment);
  // var emailRank = emailData.map((value, index) => ({
  //     value: value,

  // }));
  // var unionAdsRank = unionAdsData.map((value, index) => ({
  //     value: value,

  // }));
  // var videoAdsRank = videoAdsData.map((value, index) => ({
  //     value: value,

  // }));
  // var directRank = directData.map((value, index) => ({
  //     value: value,

  // }));

  // var seriesData = [
  //     emailRank,
  //     unionAdsRank,
  //     videoAdsRank,
  //     directRank,

  // ];

  // var option = {
  //     legend:{
  //         data:['Activity','No of Posts','Engagement Rate','No of comments'],
  //         textStyle: {
  //             color: '#2F2F2FCC',
  //             fontSize: 12,
  //             fontWeight: 400
  //           },
  //           right: 20,
  //     },
  //     tooltip: {
  //         trigger: 'axis'
  //     },
  //     grid: {
  //         left: '3%',
  //         right: '4%',
  //         bottom: '3%',
  //         containLabel: true
  //     },
  //     color:["rgba(124, 99, 164, 0.4)","rgba(214, 162, 190, 0.4)","rgba(241, 100, 128, 0.4)","rgba(212, 100, 138, 1)"],
  //     toolbox: {

  //     },
  //     xAxis: {
  //         type: 'category',
  //         boundaryGap: false,
  //         data: ['0', '1', '3', '4', '5', '6', '7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30']
  //     },
  //     yAxis: {
  //         type: 'value'
  //     },
  //     series: [
  //         {
  //             name: 'Activity',
  //             type: 'line',
  //             data: activityData,
  //             smooth: true,
  //             showSymbol: false
  //         },
  //         {
  //             name: 'No of Posts',
  //             type: 'line',
  //             data: noOfPostData,
  //             smooth: true,
  //             showSymbol: false
  //         },
  //         {
  //             name: 'Engagement Rate',
  //             type: 'line',
  //             data: engagementRateData,
  //             smooth: true,
  //             showSymbol: false
  //         },
  //         {
  //             name: 'No of comments',
  //             type: 'line',
  //             data: noOfCommentsData,
  //             smooth: true,
  //             showSymbol: false
  //         },

  //     ]
  // };

  var option = {
    legend: {
      data: ["No of Posts", "No of comments"],
      textStyle: {
        color: "#2F2F2FCC",
        fontSize: 12,
        fontWeight: 400,
      },
      right: 20,
    },
    tooltip: {
      trigger: "axis",
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
    color: ["#7C63A4", "#D4648A"],
    toolbox: {},
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: Array.from({ length: 31 }, (_, i) => (i + 1).toString()), // Generate array from 1 to 31
    },
    yAxis: {
      type: "value",
    },
    series: [
      {
        name: "No of Posts",
        type: "line",
        data: noOfPostData,
        smooth: true,
        showSymbol: false,
      },
      {
        name: "No of comments",
        type: "line",
        data: noOfCommentsData,
        smooth: true,
        showSymbol: false,
      },
    ],
  };

  return (
    <div>
      <div className="shadow-metafit-shadow bg-white border rounded-[10px]">
        <div className="visitor-chart">
          <div className="text-base font-semibold p-4">
            <Tabs
              defaultActiveKey="community"
              items={items}
              onChange={onChange}
            />
            <div className=" months-selector w-[100px] ">
              <Select defaultValue={selectedMonth} onChange={handleMonthChange}>
                {moment.months().map((monthName, index) => (
                  <Option key={index.toString()} value={index.toString()}>
                    {monthName}
                  </Option>
                ))}
              </Select>
            </div>
          </div>
        </div>
        <div className="mb-[6px]">
          <ReactEcharts option={option} />
        </div>
      </div>
    </div>
  );
};

export default VisitorChart;
